import { CatalogMode, getWithAuthn } from "../../RequestHelpers";
import { deserializeFishAmplifierCatalog, extractBufferMetadata, HcrAmplifier, PredefinedLabel } from "../automated-pro/RnaCatalog";
// Nanograms
var Ugram = /** @class */ (function () {
    function Ugram(ugram) {
        this.ugram = ugram;
    }
    Ugram.prototype.valueWithUnit = function () {
        return this.ugram + " \u03BCg";
    };
    return Ugram;
}());
export { Ugram };
var EncoderScale = /** @class */ (function () {
    function EncoderScale(slides, samples) {
        this.slides = slides;
        this.samples = samples;
    }
    return EncoderScale;
}());
export { EncoderScale };
// TODO test
export var deserializeCatalog = function (jsonCatalog) {
    var legacyProbes = jsonCatalog.legacyProbe.probes.map(function (jp) { return ({
        id: jp.id,
        name: jp.name,
        amplifiers: jp.amplifiers.map(function (a) { return ({
            id: a.id,
            amplifier: new HcrAmplifier(a.amplifier.id)
        }); })
    }); });
    var goldProbes = jsonCatalog.goldProbe.probes.map(function (jp) { return ({
        id: jp.id,
        name: jp.name,
        amplifiers: jp.amplifiers.map(function (a) { return ({
            id: a.id,
            amplifier: new HcrAmplifier(a.amplifier.id)
        }); })
    }); });
    var automatedIfDetect = {
        configs: jsonCatalog.automatedIfDetect.configs.map(function (c) { return ({
            id: c.id,
            plexity: c.plexity,
            label: c.label,
            channels: c.channels.map(function (p) { return ({
                hcrAmplifier: new HcrAmplifier(p.hcrAmplifier.id),
                fluorophore: new PredefinedLabel(p.fluorophore.id, p.fluorophore.name, p.fluorophore.isStandard),
                channel: p.channel
            }); })
        }); })
    };
    var encoderAmplifier = new Map(Object.entries(jsonCatalog.encoderAmplifier)
        .map(function (pair) { return [pair[0], deserializeFishAmplifierCatalog(pair[1])]; }));
    var legacyAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.legacyAmplifier);
    var goldAmplifier = deserializeFishAmplifierCatalog(jsonCatalog.goldAmplifier);
    var buffer = {
        sampleTypes: jsonCatalog.buffer.sampleTypes,
        defaultSampleType: jsonCatalog.buffer.defaultSampleType,
        antibody: extractBufferMetadata(jsonCatalog.buffer.antibody),
        goldAntibody: extractBufferMetadata(jsonCatalog.buffer.goldAntibody),
        antibodyWash: extractBufferMetadata(jsonCatalog.buffer.antibodyWash),
        amplification: extractBufferMetadata(jsonCatalog.buffer.amplification),
        goldAmpWash: extractBufferMetadata(jsonCatalog.buffer.goldAmpWash)
    };
    var encoderBuffer = {
        sampleTypes: jsonCatalog.encoderBuffer.sampleTypes,
        defaultSampleType: jsonCatalog.encoderBuffer.defaultSampleType,
        antibody: extractBufferMetadata(jsonCatalog.encoderBuffer.antibody),
        antibodyWash: extractBufferMetadata(jsonCatalog.encoderBuffer.antibodyWash),
        amplification: extractBufferMetadata(jsonCatalog.encoderBuffer.amplification),
        goldAmpWash: extractBufferMetadata(jsonCatalog.encoderBuffer.goldAmpWash)
    };
    var legacyProbesByAmplifierId = new Map();
    legacyProbes.forEach(function (p) {
        p.amplifiers.forEach(function (pa) {
            legacyProbesByAmplifierId.set(pa.id, p);
        });
    });
    var goldProbesByAmplifierId = new Map();
    goldProbes.forEach(function (p) {
        p.amplifiers.forEach(function (pa) {
            goldProbesByAmplifierId.set(pa.id, p);
        });
    });
    var automatedIfCustomAmplifiers = jsonCatalog.automatedIfCustomAmplifiers.map(function (a) { return new HcrAmplifier(a.id); });
    var automatedIfCustomFluorophores = jsonCatalog.automatedIfCustomFluorophores.map(function (f) { return new PredefinedLabel(f.id, f.name, f.isStandard); });
    return {
        encoder: {
            primarySpecies: jsonCatalog.encoder.primarySpecies,
            scales: jsonCatalog.encoder.scales.map(function (s) { return new EncoderScale(s.slides, s.samples); }),
            defaultScale: new EncoderScale(jsonCatalog.encoder.defaultScale.slides, jsonCatalog.encoder.defaultScale.samples)
        },
        encoderAmplifier: encoderAmplifier,
        automatedIfPlatforms: jsonCatalog.automatedIfPlatforms,
        automatedIfDetect: automatedIfDetect,
        automatedIfCustomAmplifiers: automatedIfCustomAmplifiers,
        automatedIfCustomFluorophores: automatedIfCustomFluorophores,
        automatedIfPresetScales: jsonCatalog.automatedIfPresetScales,
        automatedGoldIfSampleTypes: jsonCatalog.automatedGoldIfSampleTypes,
        legacyProbe: {
            probes: legacyProbes,
            scales: jsonCatalog.legacyProbe.scaleUgrams.map(function (s) { return new Ugram(s); }),
            defaultScale: new Ugram(jsonCatalog.legacyProbe.defaultScaleUgram),
            probesByAmplifierId: legacyProbesByAmplifierId
        },
        goldProbe: {
            probes: goldProbes,
            scales: jsonCatalog.goldProbe.scaleUgrams.map(function (s) { return new Ugram(s); }),
            defaultScale: new Ugram(jsonCatalog.goldProbe.defaultScaleUgram),
            probesByAmplifierId: goldProbesByAmplifierId
        },
        legacyAmplifier: legacyAmplifier,
        goldAmplifier: goldAmplifier,
        buffer: buffer,
        encoderBuffer: encoderBuffer
    };
};
export var fetchSecondaryIfCatalog = function (mode) {
    var path;
    switch (mode) {
        case CatalogMode.Consumer:
            path = '/order/catalog/ihc2';
            break;
        case CatalogMode.Internal:
            // TODO eventually a different catalog once we have admin only items
            path = '/order/catalog/ihc2/admin';
            break;
        default:
            throw Error("Unknown mode " + mode);
    }
    return getWithAuthn(path)
        .then(function (resp) {
        // TODO check for 200
        return resp.json();
    })
        .then(function (jsonCatalog) {
        return deserializeCatalog(jsonCatalog);
    });
};
var SecondaryIfCatalogLoader = /** @class */ (function () {
    function SecondaryIfCatalogLoader(mode) {
        this.mode = mode;
    }
    SecondaryIfCatalogLoader.prototype.load = function () {
        return fetchSecondaryIfCatalog(this.mode);
    };
    return SecondaryIfCatalogLoader;
}());
export { SecondaryIfCatalogLoader };
export var getSecondaryIfAmplifierCatalog = function (legacy, catalog) {
    return legacy ? catalog.legacyAmplifier : catalog.goldAmplifier;
};
export var getSecondaryIfProbeCatalog = function (legacy, catalog) {
    return legacy ? catalog.legacyProbe : catalog.goldProbe;
};
// Amplifier options depend on the selected encoder. When no species is selected yet, fall back to
// the first selectable species so the form always has a valid default amplifier to show.
export var encoderAmplifierCatalogFor = function (catalog, species) {
    var speciesId = species ? species.id : catalog.encoder.primarySpecies[0].id;
    var ampCatalog = catalog.encoderAmplifier.get(speciesId);
    if (ampCatalog === undefined) {
        throw new Error("No encoder amplifier catalog for species " + speciesId);
    }
    return ampCatalog;
};
//# sourceMappingURL=SecondaryIfCatalog.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/secondary-if/SecondaryIfCatalog.js
// module id = 40
// module chunks = 0